import { render, staticRenderFns } from "./_base-mini-spinner.vue?vue&type=template&id=05e7c5cc"
var script = {}
import style0 from "./_base-mini-spinner.vue?vue&type=style&index=0&id=05e7c5cc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports